<div id="nav-placeholder" class="d-print-none" *ngIf="render" [@fadeInOut]>&nbsp;</div>
<aside *ngIf="render" [@fadeInOut] class="d-print-none">
  <lib-client-nav-list [activeTab]="activeTab"></lib-client-nav-list>
</aside>
